/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from '@hono/zod-openapi';

import {
  vehicleMappingCoverageRemediationRequestSchema,
  vehicleMappingRuleRemediationRequestSchema,
  vehicleMappingSourceSignatureSchema,
} from './VehicleMappingCoverageSchemas';

export const advertisingAssistantChatRequestSchema = z
  .object({
    platformCode: z.string().trim().min(1).max(100),
    conversationId: z.string().min(1).optional(),
    message: z.string().trim().min(1).max(4_000),
    history: z
      .array(
        z.object({
          role: z.enum(['user', 'assistant']),
          content: z.string().trim().min(1).max(4_000),
        })
      )
      .max(20)
      .optional(),
  })
  .openapi('AdvertisingAssistantChatRequest');

const vehicleIssueProposalRequestSchema = z.object({
  runId: z.string().uuid(),
  issueId: z.string().uuid(),
  request: vehicleMappingCoverageRemediationRequestSchema,
});

const vehicleManualProposalRequestSchema = z.object({
  runId: z.string().uuid(),
  source: vehicleMappingSourceSignatureSchema,
  request: vehicleMappingRuleRemediationRequestSchema,
});

export const vehicleProposalRequestSchema = z.union([
  vehicleIssueProposalRequestSchema,
  vehicleManualProposalRequestSchema,
]);

export const stageAdvertisingAssistantProposalRequestSchema = z
  .object({idempotencyKey: z.string().uuid()})
  .openapi('StageAdvertisingAssistantProposalRequest');

export const stageAdvertisingAssistantProposalResponseSchema = z
  .object({
    domain: z.enum(['vehicle', 'equipment']),
    remediationId: z.string().uuid(),
    pendingCount: z.number().int().positive(),
  })
  .openapi('StageAdvertisingAssistantProposalResponse');
